import { useMemo } from 'react';

import { HealthcareFacilityPart } from '@dreryk/egabinet-healthcare-provider-frontend-api';
import { Visit } from '@dreryk/egabinet-visit-frontend-api';

import { VisitLocationData, VisitLocationType } from './VisitLocation.types';
import { VisitLocationDropdown } from './VisitLocationDropdown';
import { createVisitLocation, createVisitLocationId } from './VisitLocationDropdown.utils';

type HealthcareFacilityDropdownProps = {
   readonly healthcareFacilityLocationId: number | undefined;
   readonly healthcareFacilityUnitId: number | undefined;
   readonly disabled: boolean;
   readonly visitId: Visit['id'];
   readonly healthcareFacilityParts: HealthcareFacilityPart[];
};

export const HealthcareFacilityDropdown = (props: HealthcareFacilityDropdownProps): JSX.Element => {
   const visitLocations: VisitLocationData[] = useMemo(
      () =>
         props.healthcareFacilityParts.map(
            (part): VisitLocationData => {
               if (part.healthcareFacilityLocation) {
                  return createVisitLocation(VisitLocationType.FACILITY_LOCATION, part.healthcareFacilityLocation);
               }

               return createVisitLocation(VisitLocationType.FACILITY_UNIT, part.healthcareFacilityUnit);
            }
         ),
      [props.healthcareFacilityParts]
   );

   const initialVisitLocationId = props.healthcareFacilityLocationId
      ? createVisitLocationId(VisitLocationType.FACILITY_LOCATION, props.healthcareFacilityLocationId)
      : createVisitLocationId(VisitLocationType.FACILITY_UNIT, props.healthcareFacilityUnitId);

   return (
      <VisitLocationDropdown
         visitLocations={visitLocations}
         visitId={props.visitId}
         initialVisitLocationId={initialVisitLocationId}
         disabled={props.disabled}
      />
   );
};
